<template>
  <div>
    <div class="d-flex justify-content-end mb-2">
      <div class="d-flex align-items-center flex-wrap">
        <div>
          <img
            class="cursor-pointer mx-1"
            :style="`opacity:${selected_tab === 'map' ? 1 : 0.3}`"
            :src="require('@/assets/images/icons/list-icon.svg')"
            alt="list"
            @click.stop="selectTab('map')"
          />
        </div>
        <div>
          <img
            class="cursor-pointer mx-1"
            :style="`opacity:${selected_tab === 'reports' ? 1 : 0.3}`"
            :src="require('@/assets/images/icons/calendar-icon.svg')"
            alt="grid"
            @click.stop="selectTab('reports')"
          />
        </div>
      </div>
    </div>
    <cus-map v-if="selected_tab === 'map'" />
    <reports v-else-if="selected_tab === 'reports'" />
    <div v-else class="title d-flex align-items-center justify-content-center">
      {{ $t("no-view-found") }}
    </div>
  </div>
</template>

<script>
import CusMap from "./custom_index.vue";
import Reports from "./vue_charts_ops.vue";

export default {
  components: { CusMap, Reports },
  data() {
    return {
      selected_tab: "map",
    };
  },
  methods: {
    selectTab(tab) {
      const currentPathArray = this.$route?.path?.split("/");
      if (currentPathArray[currentPathArray?.length-1] !== tab) {
        this.$router.push(`/dashboard/${tab}`).catch(() => {});
      }
    },
  },
  watch: {
    $route(val) {
      if (val?.params?.view) {
        this.selected_tab = val.params.view;
      }
    },
  },
  mounted() {
    if (this.$route?.params?.view) {
      this.selected_tab = this.$route.params.view;
    }
  },
};
</script>
